export default [
    {
        path: '/escalafon',
        name: 'escalafon',
        component: () => import(/* webpackChunkName: "crear-escalafon" */ '../index.vue'),
    },
    {
        path: '/configuracion-escalafon/:id',
        name: 'configuracion-escalafon',
        component: () => import(/* webpackChunkName: "configuracion-escalafon" */ '../views/configuracionEscalafon.vue'),
    }
]